import { render } from "./AppButton.vue?vue&type=template&id=5fc23ba5"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=5fc23ba5&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__